<div class="modal-body">
  <div class="content">
    <div class="content__top">
      <h4>{{'company.dids.document-details.title' | translate : { number: did.number } }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__main">
      <ng-container *ngIf="did.verification_data_id">
        <vox-vd-table-readonly [data]="verificationData" [language]="currentLang" [loading]="loading">
        </vox-vd-table-readonly>
      </ng-container>
      <ng-container *ngIf="did.portability_request_id">
        <vox-portability-table-readonly [data]="selectedDoc" [language]="currentLang" [loading]="loading">
        </vox-portability-table-readonly>
      </ng-container>
    </div>
  </div>
</div>